import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import ChatList from "./ChatList";
import { ISelectedContact } from "../MessagesPage";
import { RootState } from "@store/reducers";
import dayjs from "@lib/dayjs";


interface ChatSectionProps {
  selectedContact: ISelectedContact;
}

const ChatSection = ({ selectedContact }: ChatSectionProps) => {
  const [searchParams] = useSearchParams();
  const jobId = searchParams.get("jobId");
  const onlineStatus = useSelector((state: RootState) => state.job.onlineStatus);

  // Only trust presence data that belongs to the currently selected participant.
  const participantId = selectedContact?.participantDetails?.userId;
  const isPresenceForParticipant =
    !!participantId && onlineStatus?.userId === participantId;
  const isOnline = isPresenceForParticipant && onlineStatus?.isOnline;
  const lastSeenLabel =
    isPresenceForParticipant && !isOnline && onlineStatus?.lastSeen
      ? `Last seen ${dayjs(onlineStatus.lastSeen).fromNow()}`
      : null;

  return (
    <div className="flex flex-col min-h-0 w-full flex-1">
      {selectedContact && jobId ? (
        <>
          <div className="flex items-start justify-between gap-4 py-3 pl-4 pr-8 bg-white border-b">
            <div className="flex gap-3 items-center">
              <div className="relative h-10 w-10 rounded-full flex justify-center items-center bg-gray-400">
                {selectedContact?.participantDetails?.profilePic ? (
                  <img
                    src={selectedContact?.participantDetails.profilePic}
                    className="h-full w-full object-cover rounded-full"
                    alt="Selected Profile"
                  />
                ) : (
                  <div className="text-white font-semibold uppercase text-lg">
                    {selectedContact?.participantDetails?.name?.charAt(0)}
                  </div>
                )}
                {isOnline && (
                  <span className="absolute -bottom-0.5 -right-0.5 h-3.5 w-3.5 rounded-full bg-green-500 border-2 border-white" />
                )}
              </div>

              <div className="flex flex-col h-12">
                <p className="text-charcoal font-bold text-xs">
                  {selectedContact?.participantDetails?.name}
                  <span className="font-medium text-light-black">
                    {" "}
                    {/* @ts-ignore */}
                    - {selectedContact?.participantDetails?.companyName}
                  </span>
                </p>
                <p className="text-light-black font-medium text-xss">
                  Room title -{" "}
                  <span className="text-charcoal">
                    {selectedContact?.jobTitle}
                  </span>
                </p>
                {isOnline ? (
                  <p className="flex items-center gap-1 text-green-600 font-medium text-[10px]">
                    Online
                  </p>
                ) : lastSeenLabel ? (
                  <p className="text-light-black font-medium text-[10px]">
                    {lastSeenLabel}
                  </p>
                ) : null}
                {/* <p className="text-light-black font-medium text-[11px]">
                      {selectedContact?.participantDetails.refNo}
                    </p> */}
              </div>
            </div>
            <p className="text-light-black font-medium text-xs">
              {selectedContact?.participantDetails?.referenceId}
            </p>
          </div>
          <ChatList selectedContact={selectedContact} />
        </>
      ) : (
        <div className="flex flex-col flex-1 items-center justify-center font-medium text-sm text-light-black">
          Please select some job chat.
        </div>
      )}
    </div>
  );
};

export default ChatSection;
